<template>
    <div class="bng-history-virtual-sports">
        <!-- transactions -->
        <div class="tabs is-small is-centered">
            <ul>
                <li @click="filter = 'all'; refresh()" :class="{ 'is-active': filter == 'all' }">
                    <a>{{"components.pages.history.sport.all bets" | translate}}</a>
                </li>
                <li
                    @click="filter = 'not settled'; refresh()"
                    :class="{ 'is-active': filter == 'not settled' }"
                >
                    <a>{{"components.pages.history.sport.not settled bets" | translate}}</a>
                </li>
                <li
                    @click="filter = 'settled'; refresh()"
                    :class="{ 'is-active': filter == 'settled' }"
                >
                    <a>{{"components.pages.history.sport.settled bets" | translate}}</a>
                </li>
            </ul>
        </div>

        <div
            class="box title is-5"
            v-if="!tickets || !tickets.length"
        >{{`components.pages.history.no ${filter}` | translate}}</div>
        <div v-else class="table-container">
            <table class="table is-striped is-hoverable is-fullwidth is-size-7 bk-bets bng-nowrap">
                <thead>
                    <tr>
                        <th>{{ "components.pages.history.virtual-sports.time" | translate }}</th>
                        <th>{{ "components.pages.history.virtual-sports.bet type" | translate }}</th>
                        <th>{{ "components.pages.history.virtual-sports.bet" | translate }}</th>
                        <th>{{ "components.pages.history.virtual-sports.coefficient" | translate }}</th>
                        <th>{{ "components.pages.history.virtual-sports.status" | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="ticket in tickets">
                        <tr
                            @click="toggleTicketDetails(ticket);"
                            :key="`ticket-${ticket.hdRacesTicketId}`"
                        >
                            <td>
                                <template v-if="ticket.showDetails">
                                    <span class="icon is-small">
                                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                                    </span>
                                </template>
                                <template v-else>
                                    <span class="icon is-small">
                                        <i class="fas fa-angle-right" aria-hidden="true"></i>
                                    </span>
                                </template>
                                {{ ticket.created | localDatetime }}
                            </td>
                            <td>
                                <span>{{getTicketTypeDesc(ticket) | translate}}</span>
                            </td>
                            <td>{{ ticket.ticketStake | currency(ticket.currency) }}</td>
                            <td>
                                <template v-for="(bet, i) in ticket.bets">
                                    @{{bet.rate | rate}}
                                    <template
                                        v-if="i < ticket.bets.length - 1"
                                    >,</template>
                                </template>
                            </td>
                            <td
                                :class="{'has-text-success has-text-weight-bold': ticket.status=='win', 'has-text-grey': ticket.status=='loss'}"
                            >
                                {{`hdraces.status.${ticket.status}` | translate}}
                                <template
                                    v-if="ticket.status == 'win'"
                                >({{ticket.ticketWin | currency(ticket.currency)}})</template>
                            </td>
                        </tr>
                        <tr
                            v-if="ticket.showDetails"
                            :key="`ticket-${ticket.hdRacesTicketId}-details`"
                        >
                            <td colspan="7">
                                <div class="box">
                                    <table class="table is-fullwidth is-striped">
                                        <template v-for="(bet, bi) in ticket.bets">
                                            <tr :key="`bet-${bi}`">
                                                <td class="has-text-weight-bold">
                                                    <span
                                                        v-if="bet.odds.length == 1"
                                                    >{{"hdraces.ticket.single" | translate}}</span>
                                                    <span
                                                        v-if="bet.odds.length > 1"
                                                    >{{"hdraces.ticket.express" | translate}}</span>
                                                </td>
                                                <td>{{"history.bet" | translate}} {{bet.stake | currency(ticket.currency)}}</td>
                                                <td colspan="2">@{{bet.rate | rate}}</td>
                                                <td
                                                    :class="{'has-text-success has-text-weight-bold': bet.status=='win', 'has-text-grey': bet.status=='loss'}"
                                                >{{`hdraces.status.${bet.status}` | translate}}</td>
                                            </tr>
                                            <tr
                                                v-for="(odd, oi) in bet.odds"
                                                :key="`bet-${bi}-odd-${oi}`"
                                            >
                                                <td>{{`games.hdraces.${odd.feedId}` | translate}} #{{odd.eventId}}</td>
                                                <td>
                                                    <template
                                                        v-if="getOddPlayers(odd.oddKey).length"
                                                    >
                                                        {{"hdraces.ticket.player" | translate}}
                                                        {{getOddPlayers(odd.oddKey).join(', ')}},
                                                        {{`hdraces.ticket.markets.${odd.market}` | translate}}
                                                    </template>
                                                    <template
                                                        v-else
                                                    >{{`hdraces.ticket.odds.${odd.oddKey}` | translate}}</template>
                                                </td>
                                                <td>@{{odd.rate | rate}}</td>
                                                <td>
                                                    {{"hdraces.ticket.result" | translate}}
                                                    <template
                                                        v-if="odd.eventResult && odd.eventResult.length"
                                                    >[{{odd.eventResult.join(', ')}}]</template>
                                                    <template v-else>-</template>
                                                </td>
                                                <td
                                                    :class="{'has-text-success': bet.status=='win', 'has-text-grey': bet.status=='loss'}"
                                                >{{`hdraces.status.${odd.status}` | translate}}</td>
                                            </tr>
                                        </template>
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <template v-for="(jp, jpi) in (ticket.jackpots || [])">
                            <tr
                                v-if="jp.status == 'win'"
                                :key="`ticket-${ticket.hdRacesTicketId}-jp-${jpi}`"
                            >
                                <td>{{ ticket.created | localDatetime }}</td>
                                <td colspan="3">JACKPOT!</td>
                                <td
                                    class="has-text-success has-text-weight-bold"
                                >{{`hdraces.status.win` | translate}} {{jp.win | currency(ticket.currency)}}</td>
                            </tr>
                        </template>
                    </template>
                </tbody>
            </table>
        </div>
        <!-- load more -->
        <div class="field">
        <a
            v-if="hasLoadMore"
            :class="[{ 'is-loading': loading }, 'button', 'is-info', 'is-large']"
            @click="loadMore();"
        >{{ "components.pages.history.load more" | translate }}</a>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

import hdracesService from '../../../../../../_common/services/hdraces.service';
import balanceService from '../../../../../../_common/services/balance.service';
import utils from '../../../../../../_common/utils';

import Description from '../../../common/description/description.vue';

export default {
    name: 'history-virtual-sports',
    components: { Description },
    data: () => ({
        filter: 'all',
        tickets: [],
        take: 20,
        skip: 0,
        loading: false,
        hasLoadMore: true
    }),
    computed: {
        balance: function() {
            return Vue.state.history.balance.get();
        },
        date: function() {
            return Vue.state.history.date.get();
        }
    },
    watch: {
        balance: async function() {
            await this.refresh();
        },
        date: async function() {
            await this.refresh();
        }
    },
    async mounted() {
        await this.refresh();
    },
    methods: {
        async loadMore() {
            this.skip += this.take;
            let loadedTickets = await this.getTickets();
            this.tickets.push(...loadedTickets);
            this.hasLoadMore = loadedTickets.length >= this.take;
        },
        async refresh() {
            this.skip = 0;
            let loadedTickets = await this.getTickets();
            this.tickets.splice(0, this.tickets.length);
            this.tickets.push(...loadedTickets);
            this.hasLoadMore = loadedTickets.length >= this.take;
        },
        async getTickets() {
            let statuses = [];
            if (this.filter === 'not settled') statuses = ['open'];
            if (this.filter === 'settled') statuses = ['win', 'loss', 'canceled'];
            return await hdracesService.getHdRacesTickets(this.balance.id, this.date, this.take, this.skip, statuses);
        },
        getOddPlayers(oddId) {
            return Array.from(oddId.replace(/\D+/g, '')).map(p => parseInt(p));
        },
        toggleTicketDetails(ticket) {
            this.$set(ticket, 'showDetails', !ticket.showDetails);
        },
        getTicketTypeDesc(ticket) {
            if (ticket.bets.length == 1 && ticket.bets[0].odds.length > 1) return 'hdraces.ticket.express';
            if (ticket.bets.some(b => b.odds.length > 1)) return 'hdraces.ticket.system';
            return 'hdraces.ticket.single';
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/history/virtual-sports.vue